import {
  createContext,
  useContext,
  useMemo,
  useState,
  type ReactElement,
  type ReactNode,
} from 'react';

type InLiveRoomContextValue = {
  inLiveRoom: boolean;
  setInLiveRoom: (value: boolean) => void;
};

const InLiveRoomContext = createContext<InLiveRoomContextValue>({
  inLiveRoom: false,
  setInLiveRoom: () => undefined,
});

export function InLiveRoomProvider({ children }: { children: ReactNode }): ReactElement {
  const [inLiveRoom, setInLiveRoom] = useState(false);
  const value = useMemo(() => ({ inLiveRoom, setInLiveRoom }), [inLiveRoom]);

  return <InLiveRoomContext.Provider value={value}>{children}</InLiveRoomContext.Provider>;
}

export function useInLiveRoom(): InLiveRoomContextValue {
  return useContext(InLiveRoomContext);
}
